export const PRACTICE_CATEGORIES = {
    프리다이빙: [ "자율연습반", "노핀 연습반", "프리미엄 트레이닝"],
    머메이드: ["자율연습반","프리미엄 트레이닝"],
};
